module.exports = __webpack_public_path__ + "media/referral/referral-man-da869049.svg";